import { Dimensions, Platform } from 'react-native';
import type { StackNavigationOptions } from '@react-navigation/stack';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Constants from 'src/core/utils/Constants';
import Dimens from 'src/core/utils/Dimens';
import Styles from 'src/core/utils/Styles';
import NavigationButton from 'src/presentation/components/molecules/NavigationButton';

const wideIosHeaderInset =
	Platform.OS === Constants.platformIos && Dimensions.get('window').width >= Dimens.size414
		? Dimens.paddingMinus5
		: Dimens.padding0;

export const headerLayoutOptions = {
	headerTitleAlign: 'center',
	headerTitleStyle: Styles.header.title,
	headerLeftContainerStyle: { marginStart: wideIosHeaderInset },
	headerRightContainerStyle: { marginEnd: wideIosHeaderInset },
} as const satisfies StackNavigationOptions;

export const nestedStackScreenOptions: StackNavigationOptions = {
	...headerLayoutOptions,
	cardStyle: { flex: Dimens.flex1 },
	headerBackTitle: ' ',
};

export const headerlessStackScreenOptions: StackNavigationOptions = {
	...nestedStackScreenOptions,
	headerShown: false,
};

export const transparentHeaderBackground: StackNavigationOptions = {
	headerTransparent: true,
	headerBackground: () => null,
};

export const transparentHeaderScreenOptions: StackNavigationOptions = {
	...headerLayoutOptions,
	...transparentHeaderBackground,
	headerShown: true,
	headerTitle: '',
};

type HeaderButtonOptions = {
	navigation: { goBack: () => void };
};

export function headerBackButton({ navigation }: HeaderButtonOptions) {
	return (
		<NavigationButton
			icon={SvgIconType.chevronLeft}
			iconSize={Dimens.iconSize12}
			style={{ marginHorizontal: Dimens.padding18 }}
			onPress={() => navigation.goBack()}
		/>
	);
}

export function headerBackButtonOnImage({ navigation }: HeaderButtonOptions) {
	return (
		<NavigationButton
			backgroundColor={Colors.headerButtonOnImage}
			icon={SvgIconType.chevronLeft}
			iconColor={Colors.white}
			iconSize={Dimens.iconSize12}
			pressedBackgroundColor={Colors.headerButtonOnImagePressed}
			style={{ marginHorizontal: Dimens.padding18 }}
			onPress={() => navigation.goBack()}
		/>
	);
}

export function headerCloseButtonOnImage({ navigation }: HeaderButtonOptions) {
	return (
		<NavigationButton
			backgroundColor={Colors.headerButtonOnImage}
			icon={SvgIconType.cross}
			iconColor={Colors.white}
			iconSize={Dimens.iconSize12}
			pressedBackgroundColor={Colors.headerButtonOnImagePressed}
			style={{ marginHorizontal: Dimens.padding18 }}
			onPress={() => navigation.goBack()}
		/>
	);
}

export function headerCloseButton({ navigation }: HeaderButtonOptions) {
	return (
		<NavigationButton
			backgroundColor={Colors.white}
			icon={SvgIconType.cross}
			iconColor={Colors.gray900}
			iconSize={Dimens.iconSize12}
			pressedBackgroundColor={Colors.gray150}
			style={{ marginHorizontal: Dimens.padding18 }}
			onPress={() => navigation.goBack()}
		/>
	);
}
